import Logout from './Logout'
import { withLogout } from '../../hocs/withAuthContianer'
export default withLogout(Logout)



// WEBPACK FOOTER //
// ./src/modules/Logout/index.js